/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Fragment, useState } from "react";
import "./ConfirmGatewaySelection.scss";
import {
  IGatewayRegistration,
  ISelectedGateway,
} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import { IGatewayDetails} from "../../gateway/registration/IGatewayDetails"
import { Button, Modal } from "@scuf/common";
import { GatewayRegSetup } from "./GatewayRegistrationSetup";

export interface IConfirmGatewaySelectionProps {
  gatewayDetails:IGatewayDetails;
  gatewayRegistration: IGatewayRegistration;
  cancelHandler: (confirmationRender: boolean) => void;
}

export const ConfirmGatewaySelection = (
  props: IConfirmGatewaySelectionProps
) => {
  const [sitesLoaded, setSitesLoaded] = useState(
    props.gatewayRegistration.sitesLoaded
  );
  const [selectedGateway, setSelectedGateway] = useState<ISelectedGateway>(
    props.gatewayRegistration.selectedGateway
  );
  const [renderView, setRenderView] = useState(false);

  const renderModal = () => {
    return (
      <Modal
        className="popup-theme-wrap ui-gateway-comformation-model"
        onClose={() => setSitesLoaded(false)}
        size="small"
        open={sitesLoaded}
      >
        <Modal.Content>
          <Fragment>
            <div className="ui-gateway-confirmation-title">
              Confirm Selection
            </div>
            <div className="ui-gateway-confirmation-sub-title">
              Do you wish to proceed with the following selection:
            </div>
            <div className="ui-gateway-confirmation-gateway-title">
              Gateway Name:
            </div>
            <div>{props.gatewayRegistration.selectedGateway.gatewayName}</div>
            <div className="ui-gateway-confirmation-tenant-title">Tenant:</div>
            <div>{props.gatewayRegistration.selectedGateway.tenant}</div>
            <div className="ui-gateway-confirmation-serial-number-title">
              Serial Number:
            </div>
            <div>{props.gatewayRegistration.selectedGateway.serialNumber}</div>
          </Fragment>
        </Modal.Content>
        <Modal.Footer>
          <Button
            className="ui-gateway-confirmation-button-cancle"
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              setSitesLoaded(false);
              props.cancelHandler(false);
            }}
          />
          <Button
            className="ui-gateway-confirmation-button-proceed"
            type="primary"
            size="small"
            content="Proceed"
            onClick={() => {
              setSitesLoaded(false);
              setRenderView(true);
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <div>
      <React.Fragment>{renderModal()}</React.Fragment>
      <div>
        {renderView ? (
          <GatewayRegSetup 
          gatewayDetails  = {props.gatewayDetails} 
          selectedGateway = {selectedGateway} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default ConfirmGatewaySelection;
